module.exports = __webpack_public_path__ + "img/alipayHK.eb807be3.svg";